import {Component, h} from "preact";
import styles from './style.module.scss';
import {icons} from "../icons";
import actions from "../../store/actions";
import {connect} from "redux-zero/preact";
import {FilterMap, ProductFilter} from "../../models/filter";
import {FilterType, Gender} from "../../models/product";
import {i18nService} from "../../services/i18n-service";
import {Collection} from "../../models/collection";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import {filterService} from "../../services/filter-service";
import {customerService} from "../../services/customer-service";
import {Like} from "../../models/customer";
import App from "../app";
import {NY_CountryService} from "../../services/country-service";
import {config} from "../../config";

interface Props {
    toggleIsFilterDisplayed?();

    toggleIsFilterModalDisplayed?(show?: boolean);

    toggleFilter(filter: ProductFilter);

    setGender(gender: Gender);

    clearAllFilters();

    openInterstitial();

    isFilterModalDisplayed: boolean;
    filters: FilterMap;
    initialized: boolean;
    collections: Collection[];
    isMobile: boolean;
    likes: Like[];
}

interface State {
    isFilterModalDisplayed: boolean;
}

const mapToProps = ({filters, initialized, collections, isFilterModalDisplayed, likes}) =>
    ({filters, initialized, collections, isFilterModalDisplayed, likes});

class ListHeader extends Component<Props, State> {

    componentDidMount(): void {
        this.setState({
            isFilterModalDisplayed: false
        });

        this._toggleFilterModal = this._toggleFilterModal.bind(this);
        this._toggleLikeFilter = this._toggleLikeFilter.bind(this);
    }


    private async _clearAllFilters() {
        this.props.toggleIsFilterModalDisplayed(false);
    }

    private _toggleFilterModal() {
        this.props.toggleIsFilterModalDisplayed();
    }

    private _setGender(gender: Gender) {
        this.props.setGender(gender);
        this.props.toggleIsFilterModalDisplayed(false);
    }

    private _toggleLikeFilter() {
        if (!customerService.isLoggedIn) {
            this.props.openInterstitial();
        } else {
            this.props.toggleFilter(this.props.filters.likes[0]);
        }
        this.props.toggleIsFilterModalDisplayed(false);
    }

    render() {
        if (!this.props.filters || !this.props.initialized) {
            return;
        }

        if (this.props.initialized && this.props.isMobile && this.props.filters.editorials.find(c => c.selected)) {
            return (
                <div class={styles.header} role='button'>
                    <a class={styles['header-editorial-container']}
                       href={config.url(this.props.filters.getCleanFilterUrl())}>
                        <span>{icons.renderArrowLeftIcon()}</span>
                        <span class={styles['arrow-text']}>{i18nService.translate('filter_header_all_products')}</span>
                    </a>
                </div>
            )
        }

        if (this.props.initialized && this.props.filters.editorials.find(c => c.selected)) {
            return (
                <div class={styles.header} role='button'>
                    <a class={styles['header-editorial-container']}
                       href={config.url(this.props.filters.getCleanFilterUrl())}>
                        <span class={styles['left-arrow']}>{icons.renderArrowLeftIcon()}</span>
                        <span class={styles['arrow-text']}>{i18nService.translate('filter_header_all_products')}</span>
                    </a>
                </div>
            )
        }

        return (
            <div class={styles.header} role='button'>
                <div
                    class={`${styles['header-inner-container-desktop']} ${App.countryCode === "by" ? styles['with-info'] : ''}`}>
                    <div class={styles.gender}>
                        <div
                            tabIndex={0}
                            class={`${styles['gender-item']} ${this.props.filters.gender == Gender.Female ? styles.active : null}`}
                            onClick={() => this._setGender(Gender.Female)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') this._setGender(Gender.Female)
                            }}
                            title={i18nService.translate('filter_women')}
                        >
                            {i18nService.translate('filter_women')}
                        </div>

                        <div
                            tabIndex={0}
                            class={`${styles['gender-item']} ${this.props.filters.gender == Gender.Male ? styles.active : null}`}
                            onClick={() => this._setGender(Gender.Male)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') this._setGender(Gender.Male)
                            }}
                            title={i18nService.translate('filter_men')}
                        >
                            {i18nService.translate('filter_men')}
                        </div>
                    </div>

                    {NY_CountryService.showVariablePriceCaption(App.countryCode) && (
                        <div className={styles['detail-view-hint']}>
                            {i18nService.translate('variable_price_caption')}
                        </div>
                    )}

                    <div class={styles.settings}>
                        <div class={styles.mobile}>
                            {!NY_CountryService.isRestricted(App.countryCode) &&
                                <>
                                    {customerService.isLoggedIn ?
                                        <a href={this.props.filters.toggleFilterUrl(this.props.filters.likes[0])}
                                           className={`${styles.heart} ${styles.red}`}>
                                            <span>{icons.renderHeartIcon()}</span>
                                            <span className={styles['likes-count']}>
                                                {this.props.likes.filter(like => like.product).length}
                                            </span>
                                        </a>
                                        :
                                        <div className={styles.heart} onClick={this._toggleLikeFilter}>
                                            <span>{icons.renderHeartIcon()}</span>
                                        </div>
                                    }
                                </>
                            }

                            <div class={styles.filter}
                                 onClick={() => this.props.toggleIsFilterDisplayed()}>{i18nService.translate('list_filter_title')} ({this.props.filters.selected.length}) {icons.renderCaretDownIcon()}</div>
                        </div>

                        <div class={styles.desktop}>
                            <div class={styles.filter}>
                                <span
                                    tabIndex={0}
                                    onClick={this._toggleFilterModal}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') this._toggleFilterModal()
                                    }}
                                >
                                    {i18nService.translate('list_filter_title')} ({this.props.filters.selected.length}) {icons.renderCaretDownIcon()}
                                </span>

                                {this.props.isFilterModalDisplayed && this._renderFilterModal()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    _renderFilterModal() {
        return (
            <>
                <div class={styles['filter-modal-background']}
                     onClick={() => this.props.toggleIsFilterModalDisplayed(false)}></div>
                <div class={`${styles['filter-modal']} ${this.props.isFilterModalDisplayed ? styles.show : ''}`}>
                    <div class={styles.filters}>
                        <div>
                            <a
                                href={config.url(this.props.filters.getCleanFilterUrl())}
                                class={styles.item}
                                onClick={() => this._clearAllFilters()}
                                title={i18nService.translate('list_clear_all_filters')}
                            >
                                <span>{i18nService.translate('list_clear_all_filters')}</span>
                                {icons.renderTrashIcon()}
                            </a>
                        </div>

                        {this.props.filters.selected.map((filter: ProductFilter) => {
                            return this._renderFilter(filter);
                        })}
                    </div>
                </div>
            </>
        )
    }

    _renderFilter(filter: ProductFilter) {
        return (
            <div>
                <a
                    href={this.props.filters.toggleFilterUrl(filter)}
                    class={styles.item}
                    title={filter.type === FilterType.Editorial ? filter.name : i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                >
                    <span>{`${filter.type === FilterType.Editorial ? filter.name : i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}`}</span>
                    {icons.renderCloseIcon()}
                </a>
            </div>
        )
    }
}

export default connect(mapToProps, actions)(withDeviceIndicator(ListHeader))
